import { LegalLayout } from "@/layouts/LegalLayout.tsx";

export function PrivacyPolicyPage() {
    return <LegalLayout url="/privacy-policy.html" />;
}
